/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Days_Fixed_ShortInputs */

const en_us2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places rest where it works`)
};

const pt_br2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coloca o descanso onde funciona`)
};

const es_419_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pone el descanso donde funciona`)
};

const pt_pt2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Põe o descanso onde funciona`)
};

const fr_fr2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place le repos là où il sert`)
};

const de_de2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legt Pausen dahin, wo sie wirken`)
};

const it_it2_intake_why_days_fixed_short = /** @type {(inputs: Intake_Why_Days_Fixed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mette il riposo dove serve`)
};

/**
* | output |
* | --- |
* | "Places rest where it works" |
*
* @param {Intake_Why_Days_Fixed_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_days_fixed_short = /** @type {((inputs?: Intake_Why_Days_Fixed_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Days_Fixed_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_days_fixed_short(inputs)
	if (locale === "es-419") return es_419_intake_why_days_fixed_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_days_fixed_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_days_fixed_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_days_fixed_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_days_fixed_short(inputs)
	return en_us2_intake_why_days_fixed_short(inputs)
});
export { intake_why_days_fixed_short as "intake.why.days_fixed.short" }